import PortableText from "@/components/sanity/PortableText.vue";
import { urlForImage } from "@/js/sanity/image";
export default {
  name: "PostSection5",
  components: {
    PortableText: PortableText
  },
  methods: {
    urlForImage: urlForImage
  },
  props: {
    sectionData: {
      type: Object,
      required: true
    }
  }
};